import { Box } from "@mui/material";

interface Props {
  value: number;
  variant?: "default" | "objects";
  /** shows the pointer, for a count whose cell opens a list */
  clickable?: boolean;
}

const OBJECTS_BACKGROUND = "#0E7C7B";
const ZERO_BACKGROUND = "#E7E7EC";
const ZERO_COLOR = "#9A9AA4";

/**
 * The count pills in the catalogue tables (the mockup's `.cnt`). Zero is greyed
 * out so a row with nothing attached does not read as a live number.
 */
const CountPill = ({
  value,
  variant = "default",
  clickable = false,
}: Props) => {
  const isZero = !value;

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: "26px",
        height: "20px",
        padding: "0 7px",
        borderRadius: "10px",
        fontSize: "11.5px",
        fontWeight: 600,
        fontVariantNumeric: "tabular-nums",
        cursor: clickable && !isZero ? "pointer" : "default",
        backgroundColor: isZero
          ? ZERO_BACKGROUND
          : variant === "objects"
            ? OBJECTS_BACKGROUND
            : "secondary.main",
        color: isZero ? ZERO_COLOR : "secondary.contrastText",
      }}
    >
      {value}
    </Box>
  );
};

export default CountPill;
